import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <section className="min-h-[60vh] bg-[#FAF8F2] px-4 py-20 text-center">
      <div className="mx-auto max-w-md">
        <img
          src="/icons/new_login_logo.svg"
          alt="Mondoway Logo"
          className="mx-auto mb-8 h-16 w-auto"
        />
        <h1 className="mb-3 text-2xl font-bold text-[#0F172A]">
          Page not found
        </h1>
        <p className="text-[#64748B]">
          This link is invalid or is no longer available.
        </p>
        <Link
          to="/"
          className="mt-8 inline-block rounded-lg bg-[#6A0DAD] px-5 py-3 font-semibold text-white shadow-sm transition-colors hover:bg-[#4C087D]"
        >
          Go to Mondoway home
        </Link>
      </div>
    </section>
  );
}

export default NotFound;
